<template>
  <div class="w-full h-full flex flex-col">
    <div v-if="loyaltyFeatureAvailable" class="w-full h-full flex flex-col">
      <tabs-wrapper contentClass="md:px-8 md:pt-4 overflow-y-scroll"
        v-if="loyaltyProgramExist && Object.keys(loyaltyProgramSettings).length"
        class="h-full">
        <tab title="מועדון לקוחות" description="סקירת חברי המועדון, נקודות וסטטיסטיקות" class="h-full">
          <LoyaltyProgramOverview/>
        </tab>
        <tab title="הגדרת מועדון לקוחות" description="הגדרת חוקי צבירה, הטבות ורמות חברות" class="h-full">
          <LoyaltyProgramSettings ref="settingsRef"/>
        </tab>
        <template #header-end-1>
          <Button label="שמירת שינויים" icon="pi pi-check" size="small" :loading="settingsRef?.ctaLoading" :disabled="!settingsRef?.dirty || settingsRef?.ctaLoading || settingsRef?.ctaDisabled" @click="settingsRef?.updateLoyaltyProgram()" />
        </template>
      </tabs-wrapper>

      <div v-else class="w-full h-max flex flex-col justify-center items-center my-auto">
        <img
          src="../../../assets/img/admin/no-loyalty-program.svg"
          class="w-44 mb-4"
          alt="יצירת תוכנית נאמנות">
        <span class="text-lg font-medium">נראה שאין לכם עדיין תוכנית נאמנות</span>
        <span class="text-center px-4 font-light">צרו תוכנית נאמנות עכשיו, זה לוקח כ-2 דקות, וספקו ללקוחות שלכם חוויה מדהימה!</span>
        <div
          class="relative py-2 px-4 border border-solid m-2 bg-primary-500 text-white rounded-3xl border-purple-800 flex gap-2 justify-center items-center mt-4"
          @click="createLoyaltyProgram">
          <i class="pi pi-verified"/>
          <span class="text-sm">הפעילו כעת</span>
        </div>

      </div>
    </div>

    <div v-else class="w-full h-full flex-col flex justify-center items-center relative">
      <feature-is-not-available/>
    </div>

  </div>
</template>

<script setup lang="ts">
import {computed, reactive, ref} from "vue";
import LoyaltyProgramSettings from './pages/loyalty-program/LoyaltyProgramSettings.vue';
import {checkFeatureIsAvailable} from "@torim-app/utils";
import {ClientFeatures, ILoyaltyProgram} from "@torim-app/types";
import {useAdminStore} from "@app/stores";
import {AdminRouteNames} from "@app/router/route-names";
import {LoyaltyProgramApi} from "@app/api/admin/loyalty-program-api";
import {useToast} from "vue-toastification";
import Tab from './components/admin-tabs/Tab.vue'
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const toast = useToast();
const settingsRef = ref<InstanceType<typeof LoyaltyProgramSettings>>();

trackEvent('loyalty_program_viewed');
adminStore.setPage(AdminRouteNames.LoyaltyProgram);

const loyaltyFeatureAvailable = ref(checkFeatureIsAvailable(ClientFeatures.LoyaltyProgram, adminStore.businessSiteData.plan))
const loyaltyProgramSettings = reactive<ILoyaltyProgram>(<ILoyaltyProgram><unknown>{
  discountOptions: {discountAmount: 50, numberOfAppointments: 5, promoLimitedTo: []},
  pointsOptions: {pointName: 'נקודות', percentageToGather: 5}
});

const loyaltyProgramExist = computed(() => !!adminStore.businessSiteData.loyaltyProgram);

const createLoyaltyProgram = () => {
  trackEvent('loyalty_program_enabled');
  LoyaltyProgramApi.createProgram()
    .then(() => {
      toast.success('התוכנית נוצרה בהצלחה');
      adminStore.fetchBusinessData();
    })
    .catch(() => {
      toast.error('לא הצלחנו ליצור את התוכנית, אנא נסו שוב')
    })
}

</script>

<style scoped lang="scss">

</style>
